/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import * as Hex from 'shared/geo/hex';
import * as Points from 'shared/geo/points';


const EPS = 1e-10;


export default class
{
  constructor (index, currentTriangle, externalTriangle, parent)
  {
    this.index = index;
    this.parent = parent;

    this.currentTriangle = currentTriangle;
    this.externalTriangle = externalTriangle;
  }


  getIndex ()
  {
    return this.index;
  }


  getCurrent ()
  {
    return this.currentTriangle;
  }


  getExternal ()
  {
    return this.externalTriangle;
  }


  getBorderPoints (triangle = this.currentTriangle)
  {
    return [ triangle[0], triangle[1] ];
  }


  getRotatedPoints (triangle = this.currentTriangle)
  {
    const partitionLengths = this.getBorderPartitionLengths();
    const centerDistance = this.getCenterToPartitionDistance();

    return [ { x: 0, y: partitionLengths[0] }, { x: 0, y: - partitionLengths[1] }, { x: centerDistance, y: 0 } ];
  }


  getCenterPoint (triangle = this.currentTriangle)
  {
    return triangle[2];
  }


  getPartitionPoint (triangle = this.currentTriangle)
  {
    return Points.getPerpendicularIntersection(...triangle);
  }


  getCenterToPartitionDistance (triangle = this.currentTriangle)
  {
    return Points.distance(this.getPartitionPoint(triangle), this.getCenterPoint(triangle))
  }


  getCurrentToExternalDistance ()
  {
    return this.getCenterToPartitionDistance(this.externalTriangle) - this.getCenterToPartitionDistance(this.currentTriangle);
  }


  getBorderLength (triangle = this.currentTriangle)
  {
    return Points.distance(triangle[0], triangle[1])
  }


  getBorderPartitionLengths (triangle = this.currentTriangle)
  {
    const partition = this.getPartitionPoint(triangle);

    return [ Points.distance(triangle[0], partition), Points.distance(triangle[1], partition) ];
  }


  getRotationDegrees ()
  {
   return ((this.index + 2) % Hex.getPointCount()) * 60;
  }


  getDasharray (count)
  {
    return this.getBorderLength(this.externalTriangle) / 3;
  }


  isDiagonal ()
  {
    return this.index != 1 && this.index != 4;
  }


  isExternal ()
  {
    return Math.abs(this.getCurrentToExternalDistance()) < EPS;
  }


  getLocation ()
  {
    return this.parent.getLocation();
  }


  getNeighbor ()
  {
    const neighborZone = this.parent.getNeighborGeometry(this.index);

    return neighborZone.getBorders()[(this.index + 3) % Hex.getPointCount()];
  }


};
